export default __webpack_public_path__ + "static/construction-placeholder-c7efcfb27db233fd128abc86740a7a7b.svg";